import { render, staticRenderFns } from "./MealsButton.vue?vue&type=template&id=f74103c8&scoped=true&"
import script from "./MealsButton.vue?vue&type=script&lang=js&"
export * from "./MealsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74103c8",
  null
  
)

export default component.exports